"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HtmlTextTransformer = exports.TranslationsVersion = exports.TranslationsManager = exports.Translator = exports.Transformer = exports.PrimitiveResolver = exports.HtmlResolver = exports.TranslationsDeltaApi = exports.TranslationsApi = exports.TranslationsWebStorage = void 0;
var translationsWebStorage_1 = require("./translationsStorage/translationsWebStorage");
Object.defineProperty(exports, "TranslationsWebStorage", { enumerable: true, get: function () { return translationsWebStorage_1.TranslationsWebStorage; } });
var translationsApi_1 = require("./translationsApi/translationsApi");
Object.defineProperty(exports, "TranslationsApi", { enumerable: true, get: function () { return translationsApi_1.TranslationsApi; } });
var translationsDeltaApi_1 = require("./translationsApi/translationsDeltaApi");
Object.defineProperty(exports, "TranslationsDeltaApi", { enumerable: true, get: function () { return translationsDeltaApi_1.TranslationsDeltaApi; } });
__exportStar(require("./translationsApi/types"), exports);
var htmlResolver_1 = require("./translationsResolver/htmlResolver");
Object.defineProperty(exports, "HtmlResolver", { enumerable: true, get: function () { return htmlResolver_1.HtmlResolver; } });
var primitiveResolver_1 = require("./translationsResolver/primitiveResolver");
Object.defineProperty(exports, "PrimitiveResolver", { enumerable: true, get: function () { return primitiveResolver_1.PrimitiveResolver; } });
__exportStar(require("./translationsResolver/types"), exports);
var transformer_1 = require("./translationsTransformer/transformer");
Object.defineProperty(exports, "Transformer", { enumerable: true, get: function () { return transformer_1.Transformer; } });
__exportStar(require("./translationsTransformer/types"), exports);
var translator_1 = require("./translator");
Object.defineProperty(exports, "Translator", { enumerable: true, get: function () { return translator_1.Translator; } });
var translationsManager_1 = require("./translationsManager");
Object.defineProperty(exports, "TranslationsManager", { enumerable: true, get: function () { return translationsManager_1.TranslationsManager; } });
var translationsVersion_1 = require("./translationsVersion");
Object.defineProperty(exports, "TranslationsVersion", { enumerable: true, get: function () { return translationsVersion_1.TranslationsVersion; } });
var HtmlTextTransformer_1 = require("./translationsTransformer/HtmlTextTransformer");
Object.defineProperty(exports, "HtmlTextTransformer", { enumerable: true, get: function () { return HtmlTextTransformer_1.HtmlTextTransformer; } });
__exportStar(require("./types"), exports);
//# sourceMappingURL=index.js.map